import { takeLatest, call } from "redux-saga/effects"
import { SESSION_ALIVE_NEW_TOKEN } from "./actionTypes"
import { getSessionAlive_Api } from "../../../helpers/backend_helper"
import { GET_COMPANY_FROM_URL } from "../../../components/Common/CommonFunction"


function* getSessionAlive_GenFunc({ jsonBody }) {
  const Company = GET_COMPANY_FROM_URL()
  try {
    const response = yield call(getSessionAlive_Api, jsonBody)
    if ((response.hasOwnProperty("access"))) {
      localStorage.setItem(`${Company}_token`, response.access)
    }
  } catch (error) {
  }
}
export function* sessionAlive_saga() {
  yield takeLatest(SESSION_ALIVE_NEW_TOKEN, getSessionAlive_GenFunc)
}

export default sessionAlive_saga
